import {
  THRYV_STARTER_CODES,
  MC_2_0_SIGNATUREPLANS,
  MC_2_0_PLANS,
} from './constants'

// FULSAS-13789: TGP Foundation and Thryv Basic are only offered in the catalog
// to users who hold the matching feature flag (from `user/features`). This is
// the single source of truth for both the legacy catalog (centers-and-apps.js)
// and the new CatalogGrid (productSelectionRules.js).
export const TGP_FOUNDATION_CODE = 'mc_foundation-5-thryv-m2m'
export const THRYV_BASIC_CODES = [
  'tgp_basic-5-thryv-m2m',
  'tgp_basic-5-thryv-annual',
]

// Thryv Basic behaves like TGP Foundation everywhere (same $0 tier, same
// displacement/downgrade/onboarding rules), so rules written for
// mc_foundation apply to this whole family.
export const TGP_FOUNDATION_FAMILY_CODES = [
  TGP_FOUNDATION_CODE,
  ...THRYV_BASIC_CODES,
]

// Legacy Marketing Center (Plus/Pro/Pro Enh) and Business Center plans. When
// any of these is on the account or in the cart, TGP Foundation and Thryv
// Basic are not applicable. TGP (MC 2.0) plans are deliberately not listed —
// TGP accounts can still downgrade to TGP Foundation.
export const TGP_FOUNDATION_BLOCKING_CODES = [
  'mc_plus-5-thryv-m2m',
  'mc_pro-5-thryv-m2m',
  'mc_pro_enh-5-thryv-m2m',
  'bc_plus-5-thryv-m2m',
  'bc_pro-5-thryv-m2m',
  'bc_unlm-5-thryv-m2m',
  'bc-6-thryv-m2m',
  'bc_ent-6-thryv-m2m',
  'bc_ent-unlm-5-thryv-m2m',
]

// ---- BEGIN TGP-DOWNGRADE #1 (see docs/changes/TGP-DOWNGRADE-grayout-and-gating.md) ----
// TGP tiers that may be downgraded to TGP Foundation / Thryv Basic: Starter and
// Signature (incl. Signature Plus). Premier is deliberately not included.
export const TGP_DOWNGRADE_SOURCE_CODES = [
  ...THRYV_STARTER_CODES,
  ...MC_2_0_SIGNATUREPLANS,
]

// Any TGP plan: Starter / Signature / Signature Plus / Premier (monthly and
// annual) plus TGP Foundation and Thryv Basic. Used so that one TGP plan on the
// account or in the cart never greys out another TGP plan in the catalog.
export const isTgpFamilyCode = code =>
  MC_2_0_PLANS.includes(code) || TGP_FOUNDATION_FAMILY_CODES.includes(code)

export const isTgpStarterCode = code => THRYV_STARTER_CODES.includes(code)

// Signature and Signature Plus (monthly and annual).
export const isTgpSignatureCode = code => MC_2_0_SIGNATUREPLANS.includes(code)

export const isTgpDowngradeSourceCode = code =>
  TGP_DOWNGRADE_SOURCE_CODES.includes(code)

// True when `newCode` is TGP Foundation / Thryv Basic and every plan it would
// downgrade from (`downgradedFromCodes`) is a Starter/Signature plan. Any other
// plan in the mix (Premier, BC, legacy MC...) keeps the normal downgrade rules.
export const isTgpFoundationDowngrade = (newCode, downgradedFromCodes = []) =>
  isTgpFoundationFamilyCode(newCode) &&
  downgradedFromCodes.length > 0 &&
  downgradedFromCodes.every(isTgpDowngradeSourceCode)
// ---- END TGP-DOWNGRADE #1 ----

export const TGP_FOUNDATION_FLAG = 'TGP_Foundation_Catalog_Enabled'
export const THRYV_BASIC_FLAG = 'Thryv_Basic_Catalog_Enabled'

export const isTgpFoundationCatalogEnabled = (userFeatures = {}) =>
  Boolean(userFeatures?.[TGP_FOUNDATION_FLAG])

export const isThryvBasicCatalogEnabled = (userFeatures = {}) =>
  Boolean(userFeatures?.[THRYV_BASIC_FLAG])

export const isThryvBasicCode = code => THRYV_BASIC_CODES.includes(code)

export const isTgpFoundationFamilyCode = code =>
  TGP_FOUNDATION_FAMILY_CODES.includes(code)

export const isTgpFoundationBlockingCode = code =>
  TGP_FOUNDATION_BLOCKING_CODES.includes(code)
